<script lang="ts">
  import { getContext } from 'svelte';
  import clsx from 'clsx';
  import { rightMargins } from '@athena-lib/spacing';
  import { contextKey, type CarouselContext, type CarouselItemProps } from './types';

  const context = getContext<CarouselContext>(contextKey);
  const { children, class: className }: CarouselItemProps = $props();
</script>

<li
  class={clsx(
    'flex-shrink-0 flex-grow-0 snap-center snap-always first:snap-start last:snap-end',
    context.peekNext() ? 'w-[90%] md:w-[80%]' : 'w-full',
    rightMargins.gutter,
    'last:pr-0',
    className,
  )}
>
  {@render children()}
</li>
